import React from 'react'
import { ScrollY } from '../component/scroll'
import { APP_STORE_GROUPS, appStoreHref, appStoresIn } from '../app-stores/app-stores'

const AppLinkItem = ({ store }) => {
  return (
    <React.Fragment>
      <div>
        <a className="" href={appStoreHref(store.key)} target="_blank" rel="noreferrer">
          <img height="60px" src={store.image} alt={store.name} />
        </a>
      </div>
      {store.qr &&
        <div className="ps-3">
          <img src={store.qr} width={120} height={120} alt={`QR code for ${store.name}`} />
        </div>}
    </React.Fragment>
  )
}

const Platform = ({ group }) => {
  return (
    <React.Fragment>
      <div className="py-3">
        <h2>
          {group.title}
        </h2>

        <div className="py-2">
          {group.details}
        </div>

        <div className="container-fluid p-0 m-0">
          <div className="row g-2">
            {appStoresIn(group.id).map(store =>
              <div key={store.key} className="col-12 col-sm-4 col-xl-3 col-xxl-2">
                <AppLinkItem store={store} />
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

// The store badges, by platform, from the one store list (app-stores.js).
export const AppLinks = () => {
  return (
    <ScrollY>
      {APP_STORE_GROUPS.map(group => <Platform key={group.id} group={group} />)}
    </ScrollY>
  )
}
